import request from '@/utils/request'

let Ma_trainingApi = {

  /*培训管理列表*/
  list(data) {
    return request._post('/shop/plus.ma_training.Index/index', data);
},
/*添加培训管理*/
add(data) {
    return request._post('/shop/plus.ma_training.Index/add', data);
},
/*修改培训管理*/
edit(data) {
    return request._post('/shop/plus.ma_training.Index/edit', data);
},
/*删除培训管理*/
del(data) {
    return request._post('/shop/plus.ma_training.Index/del', data);
},
/*培训管理详情*/
detail(data) {
  return request._post('/shop/plus.ma_training.Index/detail', data);
},
/*绑定人员*/
bindUser(data) {
  return request._post('/shop/plus.ma_training.Index/bindUser', data);
},
/*执行规划*/
execute(data) {
  return request._post('/shop/plus.ma_training.Index/execute', data);
},
/*终止规划*/
terminate(data) {
  return request._post('/shop/plus.ma_training.Index/terminate', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_training.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_training.Setting/getSetting', data, errorback);
    },
}
export default Ma_trainingApi;



// WEBPACK FOOTER //
// ./src/api/ma_training.js